import { create } from "zustand";

import { Theme, ThemeSelection, ThemeStore } from "@ctypes";
import { lightTheme } from "@layout";

export const useThemeStore = create<ThemeStore>((set) => ({
  theme: lightTheme,
  setTheme: (theme: Theme) => set(() => ({ theme })),
  selection: ThemeSelection.System,
  setSelection: (selection: ThemeSelection) => set(() => ({ selection })),
}));
